import {Component, Input} from '@angular/core';
import { FormBaseComponent, ValidatorService } from '@utils-lib';
import { Email } from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import { DatevMessageService } from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent extends FormBaseComponent<Email> {

  @Input()
  public stammdatenEmailadressen: Array<Email>;

  @Input()
  public require = false;

  constructor(private readonly formBuilder: FormBuilder,
    private readonly validatorService: ValidatorService,
    protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    if (this.data instanceof Array && this.data.length > 0) {
      this.data = this.data[0];
    }
    // eslint-disable-next-line max-len
    const emailPattern = /^(?=.{1,128}$)[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    this.form = this.formBuilder.group({
      email: [this.data.email, [
        this.validatorService.minLength(1),
        this.validatorService.maxLength(128),
        this.validatorService.pattern(emailPattern)
      ]],
      notiz: [this.data.notiz]
    });

    if(this.require){
      this.form.controls.email.addValidators([this.validatorService.required()]);
      this.form.controls.email.updateValueAndValidity();
    }
  }
}
